import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { getSelectedCalculations, toggleSelectedCalc } from 'features/settings/settingsSlice';
import { useCalculations, useThunkDispatch } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formGroup: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridColumnGap: theme.spacing(2),
    },
  }),
);

const CalculationsCheckboxes = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const calculations = useCalculations();
  const dispatch = useThunkDispatch();
  const selectedCalculations = useSelector(getSelectedCalculations);

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{t('calculations')}</FormLabel>
      <FormGroup className={classes.formGroup}>
        {calculations.length ? (
          calculations.map(calc => (
            <FormControlLabel
              key={calc.name}
              control={
                <Checkbox
                  checked={selectedCalculations.map(calc => calc.name).includes(calc.name)}
                  onChange={() => dispatch(toggleSelectedCalc(calc))}
                  value={calc.name}
                />
              }
              label={calc.description}
            />
          ))
        ) : (
          <CircularProgress />
        )}
      </FormGroup>
      <Typography align="left" variant="caption">
        {t('calculations_effect')}
      </Typography>
    </FormControl>
  );
};

export default CalculationsCheckboxes;
